/**
 * PDF Download utility - handles Safari/iOS detection and fallbacks.
 */
export function downloadBlob(response, fallbackName) {
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const disposition = response.headers['content-disposition'];
  const filename = disposition ? disposition.split('filename=')[1]?.replace(/"/g, '') : fallbackName;
  
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  
  if (isIOS || isSafari) {
    const reader = new FileReader();
    reader.onloadend = function() {
      const newWindow = window.open('', '_blank');
      if (newWindow) {
        newWindow.document.title = filename;
        newWindow.location.href = reader.result;
      } else {
        const url = window.URL.createObjectURL(blob);
        window.location.href = url;
        setTimeout(() => window.URL.revokeObjectURL(url), 30000);
      }
    };
    reader.readAsDataURL(blob);
  } else {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    setTimeout(() => { window.URL.revokeObjectURL(url); }, 10000);
    try { document.body.removeChild(link); } catch (_e) { void _e; }
  }
}
